import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

interface SEOMetaProps {
	title?: string
	description?: string
	image?: string
	url?: string
}

// Конфигурация SEO текстов для разных доменов
const domainSeoConfig: Record<
	string,
	{
		siteName: string
		defaultTitle: string
		defaultDescription: string
		cityPrefix: string
		countryHint?: string
	}
> = {
	'podcastbery.ru': {
		siteName: 'PODCASTBERY',
		defaultTitle: 'Найти студию записи подкастов, студию звукозаписи в России - PODCASTBERY',
		defaultDescription:
			'Уникальный агрегатор подкаст студий, где каждая запись становится произведением искусства. Мы предлагаем вам удобную платформу, где вы можете найти, сравнить и забронировать студию, идеально подходящую для ваших творческих идей',
		cityPrefix: 'в',
		countryHint: 'России',
	},
	'kz.podcastbery.ru': {
		siteName: 'PODCASTBERY Казахстан',
		defaultTitle: 'Найти студию записи подкастов в Казахстане - PODCASTBERY',
		defaultDescription:
			'Уникальный агрегатор подкаст студий в Казахстане. Найдите, сравните и забронируйте студию для записи подкастов, звукозаписи и видеосъёмки. Удобный поиск, честные отзывы.',
		cityPrefix: 'в',
		countryHint: 'Казахстане',
	},
	'by.podcastbery.ru': {
		siteName: 'PODCASTBERY Беларусь',
		defaultTitle: 'Найти студию записи подкастов в Беларуси - PODCASTBERY',
		defaultDescription:
			'Уникальный агрегатор подкаст студий в Беларуси. Найдите, сравните и забронируйте студию для записи подкастов, звукозаписи и видеосъёмки. Удобный поиск, честные отзывы.',
		cityPrefix: 'в',
		countryHint: 'Беларуси',
	},
	'uz.podcastbery.ru': {
		siteName: 'PODCASTBERY Узбекистан',
		defaultTitle: 'Найти студию записи подкастов в Узбекистане - PODCASTBERY',
		defaultDescription:
			'Уникальный агрегатор подкаст студий в Узбекистане. Найдите, сравните и забронируйте студию для записи подкастов, звукозаписи и видеосъёмки.',
		cityPrefix: 'в',
		countryHint: 'Узбекистане',
	},
	'kg.podcastbery.ru': {
		siteName: 'PODCASTBERY Кыргызстан',
		defaultTitle: 'Найти студию записи подкастов в Кыргызстане - PODCASTBERY',
		defaultDescription:
			'Уникальный агрегатор подкаст студий в Кыргызстане. Найдите, сравните и забронируйте студию для записи подкастов, звукозаписи и видеосъёмки.',
		cityPrefix: 'в',
		countryHint: 'Кыргызстане',
	},
	'am.podcastbery.ru': {
		siteName: 'PODCASTBERY Армения',
		defaultTitle: 'Найти студию записи подкастов в Армении - PODCASTBERY',
		defaultDescription:
			'Уникальный агрегатор подкаст студий в Армении. Найдите, сравните и забронируйте студию для записи подкастов, звукозаписи и видеосъёмки.',
		cityPrefix: 'в',
		countryHint: 'Армении',
	},
	'az.podcastbery.ru': {
		siteName: 'PODCASTBERY Азербайджан',
		defaultTitle: 'Найти студию записи подкастов в Азербайджане - PODCASTBERY',
		defaultDescription:
			'Уникальный агрегатор подкаст студий в Азербайджане. Найдите, сравните и забронируйте студию для записи подкастов, звукозаписи и видеосъёмки.',
		cityPrefix: 'в',
		countryHint: 'Азербайджане',
	},
	'ge.podcastbery.com': {
		siteName: 'PODCASTBERY Грузия',
		defaultTitle: 'Найти студию записи подкастов в Грузии - PODCASTBERY',
		defaultDescription:
			'Уникальный агрегатор подкаст студий в Грузии. Найдите, сравните и забронируйте студию для записи подкастов, звукозаписи и видеосъёмки.',
		cityPrefix: 'в',
		countryHint: 'Грузии',
	},
	'tr.podcastbery.com': {
		siteName: 'PODCASTBERY Турция',
		defaultTitle: 'Найти студию записи подкастов в Турции - PODCASTBERY',
		defaultDescription:
			'Уникальный агрегатор подкаст студий в Турции. Найдите, сравните и забронируйте студию для записи подкастов, звукозаписи и видеосъёмки.',
		cityPrefix: 'в',
		countryHint: 'Турции',
	},
	'ae.podcastbery.com': {
		siteName: 'PODCASTBERY ОАЭ',
		defaultTitle: 'Найти студию записи подкастов в ОАЭ - PODCASTBERY',
		defaultDescription:
			'Уникальный агрегатор подкаст студий в ОАЭ. Найдите, сравните и забронируйте студию для записи подкастов, звукозаписи и видеосъёмки.',
		cityPrefix: 'в',
		countryHint: 'ОАЭ',
	},
	'th.podcastbery.com': {
		siteName: 'PODCASTBERY Таиланд',
		defaultTitle: 'Найти студию записи подкастов в Таиланде - PODCASTBERY',
		defaultDescription:
			'Уникальный агрегатор подкаст студий в Таиланде. Найдите, сравните и забронируйте студию для записи подкастов, звукозаписи и видеосъёмки.',
		cityPrefix: 'в',
		countryHint: 'Таиланде',
	},
	'id.podcastbery.com': {
		siteName: 'PODCASTBERY Индонезия',
		defaultTitle: 'Найти студию записи подкастов в Индонезии - PODCASTBERY',
		defaultDescription:
			'Уникальный агрегатор подкаст студий в Индонезии. Найдите, сравните и забронируйте студию для записи подкастов, звукозаписи и видеосъёмки.',
		cityPrefix: 'в',
		countryHint: 'Индонезии',
	},
}

// Функция получения SEO конфига по hostname
function getDomainSeoConfig(hostname: string) {
	const cleanHostname = hostname.replace(/^www\./, '')
	return domainSeoConfig[cleanHostname] || domainSeoConfig['podcastbery.ru']
}

// Список городов
const Cities = [
	{ code: 'moskva', name: 'Москва', id: 1 },
	{ code: 'krasnoyarsk', name: 'Красноярск', id: 2 },
	{ code: 'sankt-peterburg', name: 'Санкт-Петербург', id: 5 },
	{ code: 'novosibirsk', name: 'Новосибирск', id: 6 },
	{ code: 'ekaterinburg', name: 'Екатеринбург', id: 7 },
	{ code: 'kazan', name: 'Казань', id: 8 },
	{ code: 'nizhniy-novgorod', name: 'Нижний Новгород', id: 9 },
	{ code: 'chelyabinsk', name: 'Челябинск', id: 10 },
	{ code: 'samara', name: 'Самара', id: 11 },
	{ code: 'ufa', name: 'Уфа', id: 12 },
	{ code: 'rostov-na-donu', name: 'Ростов-на-Дону', id: 13 },
	{ code: 'omsk', name: 'Омск', id: 14 },
	{ code: 'voronezh', name: 'Воронеж', id: 15 },
	{ code: 'perm', name: 'Пермь', id: 16 },
	{ code: 'volgograd', name: 'Волгоград', id: 17 },
	{ code: 'saratov', name: 'Саратов', id: 18 },
	{ code: 'tolyatti', name: 'Тольятти', id: 20 },
	{ code: 'barnaul', name: 'Барнаул', id: 21 },
	{ code: 'mahachkala', name: 'Махачкала', id: 22 },
	{ code: 'izhevsk', name: 'Ижевск', id: 23 },
	{ code: 'habarovsk', name: 'Хабаровск', id: 24 },
	{ code: 'ulyanovsk', name: 'Ульяновск', id: 25 },
	{ code: 'irkutsk', name: 'Иркутск', id: 26 },
	{ code: 'vladivostok', name: 'Владивосток', id: 27 },
	{ code: 'yaroslavl', name: 'Ярославль', id: 28 },
	{ code: 'sevastopol', name: 'Севастополь', id: 29 },
	{ code: 'tomsk', name: 'Томск', id: 30 },
	{ code: 'stavropol', name: 'Ставрополь', id: 31 },
	{ code: 'kemerovo', name: 'Кемерово', id: 32 },
	{ code: 'naberezhnye-chelny', name: 'Набережные Челны', id: 33 },
	{ code: 'orenburg', name: 'Оренбург', id: 34 },
	{ code: 'novokuzneck', name: 'Новокузнецк', id: 35 },
	{ code: 'ryazan', name: 'Рязань', id: 36 },
	{ code: 'cheboksary', name: 'Чебоксары', id: 37 },
	{ code: 'penza', name: 'Пенза', id: 38 },
	{ code: 'lipeck', name: 'Липецк', id: 39 },
	{ code: 'kaliningrad', name: 'Калининград', id: 40 },
	{ code: 'astrahan', name: 'Астрахань', id: 42 },
	{ code: 'tula', name: 'Тула', id: 43 },
	{ code: 'sochi', name: 'Сочи', id: 44 },
	{ code: 'ulan-ude', name: 'Улан-Удэ', id: 45 },
	{ code: 'kursk', name: 'Курск', id: 46 },
	{ code: 'tver', name: 'Тверь', id: 47 },
	{ code: 'magnitogorsk', name: 'Магнитогорск', id: 48 },
	{ code: 'bryansk', name: 'Брянск', id: 49 },
	{ code: 'yakutsk', name: 'Якутск', id: 50 },
	{ code: 'ivanovo', name: 'Иваново', id: 51 },
	{ code: 'vladimir', name: 'Владимир', id: 52 },
	{ code: 'simferopol', name: 'Симферополь', id: 53 },
	{ code: 'nizhniy-tagil', name: 'Нижний Тагил', id: 54 },
	{ code: 'kaluga', name: 'Калуга', id: 55 },
	{ code: 'belgorod', name: 'Белгород', id: 56 },
	{ code: 'chita', name: 'Чита', id: 57 },
	{ code: 'groznyy', name: 'Грозный', id: 58 },
	{ code: 'smolensk', name: 'Смоленск', id: 59 },
	{ code: 'podolsk', name: 'Подольск', id: 60 },
	{ code: 'novorossiysk', name: 'Новороссийск', id: 61 },
	{ code: 'vladikavkaz', name: 'Владикавказ', id: 62 },
	{ code: 'krasnodar', name: 'Краснодар', id: 65 },
	{ code: 'zheleznogorsk', name: 'Железногорск', id: 66 },
	{ code: 'krasnogorsk', name: 'Красногорск', id: 67 },
	{ code: 'volzhskiy', name: 'Волжский', id: 70 },
	{ code: 'pyatigorsk', name: 'Пятигорск', id: 71 },
	{ code: 'kirov', name: 'Киров', id: 72 },
	{ code: 'tyumen', name: 'Тюмень', id: 73 },
	{ code: 'anapa', name: 'Анапа', id: 74 },
	{ code: 'balakovo', name: 'Балаково', id: 75 },
	{ code: 'magadan', name: 'Магадан', id: 76 },
	{ code: 'astana', name: 'Астана', id: 77 },
	{ code: 'karaganda', name: 'Караганда', id: 78 },
	{ code: 'almaty', name: 'Алматы', id: 79 },
	{ code: 'minsk', name: 'Минск', id: 80 },
	{ code: 'erevan', name: 'Ереван', id: 82 },
	{ code: 'tashkent', name: 'Ташкент', id: 83 },
	{ code: 'tbilisi', name: 'Тбилиси', id: 84 },
	{ code: 'aydyn', name: 'Айдын', id: 86 },
	{ code: 'stambul', name: 'Стамбул', id: 85 },
	{ code: 'dubay', name: 'Дубай', id: 87 },
	{ code: 'pattayya', name: 'Паттайя', id: 88 },
	{ code: 'nyu-deli', name: 'Нью-Дели', id: 89 },
	{ code: 'bangalor', name: 'Бангалор', id: 90 },
	{ code: 'noida', name: 'Ноида', id: 91 },
	{ code: 'chennai', name: 'Ченнаи', id: 92 },
	{ code: 'dzhaypur', name: 'Джайпур', id: 93 },
	{ code: 'kanpur', name: 'Канпур', id: 94 },
	{ code: 'porvorim', name: 'Порворим', id: 95 },
	{ code: 'phuket', name: 'Пхукет', id: 96 },
	{ code: 'chiangmay', name: 'Чиангмай', id: 97 },
	{ code: 'samuy', name: 'Самуй', id: 98 },
	{ code: 'bangkok', name: 'Бангкок', id: 99 },
	{ code: 'denpasar', name: 'Денпасар', id: 100 },
	{ code: 'baku', name: 'Баку', id: 101 },
	{ code: 'ashgabat', name: 'Ашхабад', id: 103 },
	{ code: 'bishkek', name: 'Бишкек', id: 104 },
	{ code: 'gelendzhik', name: 'Геленджик', id: 105 },
	{ code: 'eysk', name: 'Ейск', id: 106 },
	{ code: 'surgut', name: 'Сургут', id: 107 },
	{ code: 'saransk', name: 'Саранск', id: 108 },
	{ code: 'zelenodolsk', name: 'Зеленодольск', id: 109 },
	{ code: 'sergiev-posad', name: 'Сергиев Посад', id: 110 },
]

// Глобальные категории
const GLOBAL_CATS = [
	{ name: 'zapis-podkastov', orig: 'Запись подкастов', val: 'Студии записи подкастов' },
	{ name: 'zvukozapis', orig: 'Звукозапись', val: 'Студии звукозаписи' },
	{ name: 'videoprodakshn', orig: 'Видеопродакшен', val: 'Студии видеопродакшена' },
	{ name: 'fotostudii', orig: 'Фотостудии', val: 'Фотостудии', val2: 'фотостудию' },
	{ name: 'zapis-vebinara-kursa', orig: 'Запись вебинара/курса', val: 'Студии записи вебинара/курса' },
	{
		name: 'zapis-korotkih-video-dlya-soc-setey',
		orig: 'Запись коротких видео для социальных сетей',
		val: 'Студии записи коротких видео для социальных сетей',
	},
	{ name: 'arenda-studii', orig: 'Аренда студии', val: 'Аренда студий' },
	{ name: 'vyezdnaya-zapis-podkastov', orig: 'Выездная запись подкастов', val: 'Выездная запись подкастов' },
	{ name: 'arenda-oborudovaniya', orig: 'Аренда оборудования', val: 'Аренда оборудования' },
	{
		name: 'onlayn-translyaciya-pryamoy-efir',
		orig: 'Онлайн-трансляция/Прямой эфир',
		val: 'Онлайн-трансляция/Прямой эфир',
	},
]

// Статические страницы
const pages = [
	{
		path: '/signup',
		title: 'Регистрация на платформе PODCASTBERY',
		description: 'Создайте аккаунт на PODCASTBERY и начните публиковать свои подкасты.',
	},
	{
		path: '/signin',
		title: 'Вход в аккаунт PODCASTBERY',
		description: 'Войдите в свой аккаунт PODCASTBERY, чтобы управлять подкастами.',
	},
	{
		path: '/rules',
		title: 'Правила и условия использования PODCASTBERY',
		description: 'Ознакомьтесь с правилами размещения контента.',
	},
	{
		path: '/cities',
		title: 'Все города присутствия - PODCASTBERY',
		description: 'Полный список городов, где представлены студии PODCASTBERY.',
	},
	{ path: '/acceptance', title: 'Акцепт оферты - PODCASTBERY', description: 'Акцепт оферты на бронирование студий.' },
	{
		path: '/user_agreement',
		title: 'Пользовательское соглашение - PODCASTBERY',
		description: 'Пользовательское соглашение сервиса PODCASTBERY.',
	},
	{
		path: '/policy',
		title: 'Политика обработки персональных данных - PODCASTBERY',
		description: 'Политика обработки персональных данных.',
	},
	{
		path: '/blog',
		title: 'Всё о подкастах, актуальные новости из мира подкастов',
		description: 'Погружайтесь в мир подкастов с нашим блогом!',
	},
	{
		path: '/podcasts',
		title: 'Новые подкасты 2025 года: свежие выпуски и интересные темы - PODCASTBERY',
		description: 'Откройте для себя новые подкасты.',
	},
	{
		path: '/connect',
		title: 'PODCASTBERY - Стать партнером',
		description: 'Мы предоставляем клиенту доступ к эксклюзивной базе данных студий.',
	},
	{ path: '/account', title: 'PODCASTBERY - Личный кабинет', description: 'Уникальный агрегатор подкаст студий.' },
	{
		path: '/partner',
		title: 'PODCASTBERY - Личный кабинет партнера',
		description: 'Уникальный агрегатор подкаст студий.',
	},
	{
		path: '/about',
		title: 'PODCASTBERY - О сервисе',
		description: 'Мы разрабатываем уникальные решения в медиа-сегменте.',
	},
	{ path: '/otzyvy', title: 'Отзывы на подкаст-студии - PODCASTBERY', description: 'Отзывы на подкаст-студии.' },
]

const pagesCats = [
	{
		path: '/zapis-podkastov',
		title: 'Найти студию записи подкастов - PODCASTBERY',
		description: 'Уникальный агрегатор подкаст студий.',
	},
	{
		path: '/zvukozapis',
		title: 'Найти студию звукозаписи - PODCASTBERY',
		description: 'Уникальный агрегатор студий звукозаписи.',
	},
	{ path: '/fotostudii', title: 'Найти фотостудию - PODCASTBERY', description: 'Уникальный агрегатор фотостудий.' },
	{
		path: '/zapis-vebinara-kursa',
		title: 'Найти студию записи вебинара / курса - PODCASTBERY',
		description: 'Уникальный агрегатор подкаст студий записи вебинара.',
	},
	{
		path: '/zapis-korotkih-video-dlya-soc-setey',
		title: 'Найти студию записи коротких видео для социальных сетей - PODCASTBERY',
		description: 'Уникальный агрегатор подкаст студий записи коротких видео.',
	},
	{
		path: '/onlayn-translyaciya-pryamoy-efir',
		title: 'Найти студию для онлайн трансляций и прямых эфиров - PODCASTBERY',
		description: 'Уникальный агрегатор студий для онлайн трансляций.',
	},
	{
		path: '/arenda-studii',
		title: 'Арендовать студию записи подкастов - PODCASTBERY',
		description: 'Уникальный агрегатор подкаст студий.',
	},
	{
		path: '/vyezdnaya-zapis-podkastov',
		title: 'Выездная запись подкастов - PODCASTBERY',
		description: 'Уникальный агрегатор подкаст студий.',
	},
	{
		path: '/arenda-oborudovaniya',
		title: 'Аренда оборудования - PODCASTBERY',
		description: 'Уникальный агрегатор подкаст студий.',
	},
]

const basicPage = {
	path: '/',
	title: 'Найти студию записи подкастов, студию звукозаписи - PODCASTBERY',
	description: 'Уникальный агрегатор подкаст студий, где каждая запись становится произведением искусства.',
}

// Функция склонения городов
function declension(str: string): string {
	const specialCases: Record<string, string> = {
		сочи: 'Сочи',
		тольятти: 'Тольятти',
		баку: 'Баку',
		алматы: 'Алматы',
		караганда: 'Караганде',
		астана: 'Астане',
		бишкек: 'Бишкеке',
		дубай: 'Дубае',
		стамбул: 'Стамбуле',
		паттайя: 'Паттайе',
		бангалор: 'Бангалоре',
		ченнаи: 'Ченнаи',
		'нью-дели': 'Нью-Дели',
		пхукет: 'Пхукете',
		бангкок: 'Бангкоке',
		самуй: 'Самуе',
	}

	const lowerStr = str.toLowerCase()
	for (const [key, value] of Object.entries(specialCases)) {
		if (lowerStr.includes(key)) return value
	}

	if (lowerStr.endsWith('ий') || lowerStr.endsWith('ый') || lowerStr.endsWith('ск')) {
		return `${str}е`
	}

	if (lowerStr.endsWith('ь')) {
		const base = str.slice(0, -1)
		if (lowerStr.includes('тюмен')) return 'Тюмени'
		if (lowerStr.includes('рязан')) return 'Рязани'
		if (lowerStr.includes('перм')) return 'Перми'
		if (lowerStr.includes('твер')) return 'Твери'
		return `${base}и`
	}

	if (lowerStr.endsWith('а') || lowerStr.endsWith('я')) {
		if (lowerStr.includes('москв')) return 'Москве'
		if (lowerStr.includes('казан')) return 'Казани'
		if (lowerStr.includes('астрахан')) return 'Астрахани'
		if (lowerStr.includes('калуг')) return 'Калуге'
		if (lowerStr.includes('тул')) return 'Туле'
		if (lowerStr.includes('пенз')) return 'Пензе'
		if (lowerStr.includes('уф')) return 'Уфе'
		if (lowerStr.includes('чебоксар')) return 'Чебоксарах'
		if (lowerStr.includes('махачкал')) return 'Махачкале'
		if (lowerStr.includes('ярославл')) return 'Ярославле'
		if (lowerStr.includes('анап')) return 'Анапе'
		return `${str.slice(0, -1)}е`
	}

	if (lowerStr.endsWith('о')) {
		if (lowerStr.includes('иванов')) return 'Иваново'
		if (lowerStr.includes('кемеров')) return 'Кемерово'
		return str
	}

	if (lowerStr.includes('град') || lowerStr.includes('город')) {
		if (lowerStr.includes('волгоград')) return 'Волгограде'
		if (lowerStr.includes('калининград')) return 'Калининграде'
		if (lowerStr.includes('белгород')) return 'Белгороде'
		if (lowerStr.includes('нижний новгород')) return 'Нижнем Новгороде'
		return `${str}е`
	}

	if (lowerStr.includes('бург')) {
		if (lowerStr.includes('петербург')) return 'Санкт-Петербурге'
		if (lowerStr.includes('екатеринбург')) return 'Екатеринбурге'
		if (lowerStr.includes('оренбург')) return 'Оренбурге'
		return `${str}е`
	}

	return `${str}е`
}

// Функция генерации OG данных для города
function generateCityOpenGraph(city: any, category: any | undefined, hostname: string) {
	const config = getDomainSeoConfig(hostname)
	const cityName = declension(city.name)
	const preposition = city.name.toLowerCase().includes('влади') ? 'во' : config.cityPrefix

	let title = ''
	let description = ''

	if (category) {
		title = `${category.val} ${preposition} ${cityName} | ${config.siteName}`
		description = `Аренда студии для ${category.orig.toLowerCase()} ${preposition} ${cityName}. Профессиональное оборудование, удобное расположение, выгодные цены. Забронируйте студию онлайн на ${config.siteName}.`
	} else {
		title = `Студии ${preposition} ${cityName} — аренда подкаст студий, звукозапись | ${config.siteName}`
		description = `Каталог студий ${preposition} ${cityName}: подкаст-студии, студии звукозаписи, видеостудии, фотостудии. Цены, отзывы, онлайн-бронирование.`
	}

	if (config.countryHint && !category) {
		description += ` Актуальные студии ${preposition} ${config.countryHint}.`
	}

	return { title, description, cityName: city.name }
}

// Хелпер для экранирования HTML
function escapeHtml(str: string): string {
	if (!str) return ''
	return str
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;')
}

export const SEOMeta = ({ title, description, image, url }: SEOMetaProps) => {
	const location = useLocation()
	const [meta, setMeta] = useState({ title: '', description: '' })

	useEffect(() => {
		// Если мета-теги переданы через пропсы - используем их
		if (title && description) {
			setMeta({ title, description })
			return
		}

		const pathname = location.pathname
		const url_spl = pathname.split('/').filter(Boolean)
		const hostname = typeof window !== 'undefined' ? window.location.hostname : 'podcastbery.ru'

		let superTtl = ''
		let superDesc = ''

		// Получаем конфиг для текущего домена
		const seoConfig = getDomainSeoConfig(hostname)

		// Определяем базовую страницу из статического списка
		let foundPage = basicPage
		const allPages = [...pages, ...pagesCats]

		// Проверяем точное совпадение пути
		let exactMatch = allPages.find((v) => v.path === pathname)
		if (exactMatch) {
			foundPage = exactMatch
		} else {
			// Проверяем, является ли URL страницей города
			const isCityPage = !!(url_spl[0] && Cities.find((c) => c.code === url_spl[0]))

			// Проверяем частичное совпадение
			let partialMatch = allPages.find((v) => pathname.includes(v.path))
			if (partialMatch) {
				foundPage = partialMatch
			} else {
				foundPage = basicPage
			}
		}

		// ========== ЕДИНАЯ ЛОГИКА ЗАПОЛНЕНИЯ TITLE/DESCRIPTION ==========

		// 1. Блог (если есть поддержка в клиенте)
		if (url_spl[0] === 'blog' && url_spl[1] && url_spl[1] !== 'undefined') {
			// Здесь можно добавить загрузку поста из стора
			// Пока используем базовые мета-теги
			superTtl = foundPage.title
			superDesc = foundPage.description
		}

		// 2. Главная страница
		else if (url_spl.length === 0 || pathname === '/') {
			superTtl = seoConfig.defaultTitle
			superDesc = seoConfig.defaultDescription
		}

		// 3. Страницы с городом в первом сегменте
		else if (url_spl[0] && url_spl[0] !== 'undefined') {
			const cityCode = url_spl[0]
			const exCity = Cities.find((ct) => ct.code.toLowerCase() === cityCode.toLowerCase())

			if (exCity) {
				// 3.1 Страница города (нет второго сегмента)
				const hasSecondSegment = url_spl[1] && url_spl[1] !== 'undefined'
				const isCategoryPage = hasSecondSegment && GLOBAL_CATS.some((cat) => cat.name === url_spl[1])
				const isStudioPage = hasSecondSegment && !isCategoryPage

				// 3.1.1 Страница города
				if (!hasSecondSegment) {
					const ogData = generateCityOpenGraph(exCity, undefined, hostname)
					superTtl = ogData.title
					superDesc = ogData.description
				}
				// 3.1.2 Страница категории (например /moskva/zapis-podkastov)
				else if (isCategoryPage) {
					const exCat = GLOBAL_CATS.find((v) => v.name === url_spl[1])
					const ogData = generateCityOpenGraph(exCity, exCat, hostname)
					superTtl = ogData.title
					superDesc = ogData.description
				}
				// 3.1.3 Страница студии (например /moskva/nazvanie-studii)
				else if (isStudioPage) {
					return

					// const preposition = exCity.name.toLowerCase().includes('влади') ? 'во' : seoConfig.cityPrefix
					// // Для студий нужно будет подгружать данные из store
					// // Пока используем временные мета-теги
					// superTtl = `Студия ${preposition} ${declension(exCity.name)} | ${seoConfig.siteName}`
					// superDesc = `Подробная информация о студии ${preposition} ${declension(exCity.name)}. Оборудование, цены, отзывы, онлайн-бронирование.`
				}
			}
		}

		// 4. Если ничего не подошло, используем foundPage
		if (!superTtl) {
			superTtl = foundPage.title
		}
		if (!superDesc) {
			superDesc = foundPage.description
		}

		setMeta({ title: superTtl, description: superDesc })
	}, [location.pathname, title, description])

	return (
		<Helmet>
			<title>{meta.title}</title>
			<meta name='description' content={meta.description} />
			<meta property='og:type' content={location.pathname === '/' ? 'website' : 'article'} />
			<meta property='og:site_name' content='PODCASTBERY' />
			<meta property='og:title' content={meta.title} />
			<meta property='og:description' content={meta.description} />
			<meta property='og:url' content={url || `https://podcastbery.ru${location.pathname}`} />
			<meta property='og:image' content={image || 'https://podcastbery.ru/og-image.jpg'} />
			<meta property='og:image:width' content='1200' />
			<meta property='og:image:height' content='630' />
			<meta property='og:locale' content='ru_RU' />
			<link rel='canonical' href={`https://podcastbery.ru${location.pathname}`} />
		</Helmet>
	)
}
